import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";

export type StatTone = "default" | "orange" | "green" | "red" | "purple" | "teal";

export type StatVariant = "default" | "highlight";

interface Props {
  label: string;
  value: string | number | null | undefined;
  tone?: StatTone;
  variant?: StatVariant;
}

const TONE_CLASSES: Record<StatTone, string> = {
  default: "text-foreground",
  orange: "text-orange-600",
  green: "text-green-600",
  red: "text-red-600",
  purple: "text-purple-600",
  teal: "text-teal-700",
};

export function StatCard({ label, value, tone = "default", variant = "default" }: Props) {
  const displayValue =
    value === null || value === undefined || value === "" ? "—" : String(value);
  const isEmpty = displayValue === "—";
  const isHighlight = variant === "highlight";

  return (
    <Card
      className={cn(
        isHighlight
          ? "bg-teal-500/5 border-teal-200/50 shadow-none"
          : "bg-muted/30 border-border/30 shadow-none"
      )}
      data-testid={`stat-card-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <CardContent className="p-3 text-center space-y-1">
        <p
          className={cn(
            "font-bold",
            isHighlight ? "text-base" : "text-2xl",
            isEmpty ? "text-muted-foreground" : TONE_CLASSES[tone]
          )}
        >
          {displayValue}
        </p>
        <p className="text-xs text-muted-foreground">{label}</p>
      </CardContent>
    </Card>
  );
}
